import request from '@/utils/request';

//获取所有门店的门店信息
export const getAllStoreInformation = (values) => {
  return request('/global-report/queryStoreReport', {
    method: 'POST',
    data: values,
  });
};
